import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { jsx } from '@emotion/react';
import { useRef } from 'react';
import { useFocusable } from 'react-aria';

const FocusableTrigger = (_a) => {
  var { children, className, onClick, onFocusChange, tag = "div" } = _a, props = __rest(_a, ["children", "className", "onClick", "onFocusChange", "tag"]);
  const ref = useRef(null);
  const { focusableProps } = useFocusable({ onFocusChange }, ref);
  const Tag = tag;
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    jsx(Tag, Object.assign({}, props, focusableProps, { className, "data-zds": true, onClick, ref, tabIndex: 0 }), children)
  );
};

export { FocusableTrigger };
//# sourceMappingURL=FocusableTrigger.es.js.map
